"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStatesResponse = exports.TerritoryAssignmentRemoveResponse = exports.TerritoryAssignmentRemove = exports.TerritoryAssignmentQuery = exports.TerritoryAssignmentCreate = exports.TerritoryAssignment = void 0;
const typebox_1 = require("@sinclair/typebox");
const meta_data_1 = require("../common/meta-data");
const us_state_1 = require("../pricing/us-state");
exports.TerritoryAssignment = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    state: us_state_1.UsStateAbbreviation,
    territoryManagerProfileID: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    expiresAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: meta_data_1.MetaData,
});
exports.TerritoryAssignmentCreate = typebox_1.Type.Object({
    territoryManagerProfileID: typebox_1.Type.String({ format: 'uuid' }),
    states: typebox_1.Type.Array(us_state_1.UsStateAbbreviation),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.TerritoryAssignmentQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer({ minimum: 1, maximum: 100 }),
    offset: typebox_1.Type.Integer({ minimum: 0 }),
    includeExpired: typebox_1.Type.Boolean(),
    state: us_state_1.UsStateAbbreviation,
    territoryManagerProfileID: typebox_1.Type.String({ format: 'uuid' }),
}));
exports.TerritoryAssignmentRemove = typebox_1.Type.Object({
    territoryManagerProfileID: typebox_1.Type.String({ format: 'uuid' }),
    states: typebox_1.Type.Array(us_state_1.UsStateAbbreviation),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.TerritoryAssignmentRemoveResponse = typebox_1.Type.Object({
    removed: typebox_1.Type.Array(exports.TerritoryAssignment),
    remaining: typebox_1.Type.Array(exports.TerritoryAssignment),
});
exports.MyStatesResponse = typebox_1.Type.Object({
    states: typebox_1.Type.Array(us_state_1.UsStateAbbreviation),
});
//# sourceMappingURL=territory-assignment-transport.js.map